import { Component, OnInit, ViewChild } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';

import { AppComponent } from 'src/app/app.component';
import { environment } from 'src/environments/environment';

import { jqxWindowComponent } from 'jqwidgets-ng/jqxwindow';
import { jqxRadioButtonGroupComponent } from 'jqwidgets-ng/jqxRadioButtonGroup';

import { EjercicioAnualModel } from 'src/app/services/ejercicioAnual/models/ejercicio-anual.model';
import { EjercicioAnualService } from 'src/app/services/ejercicioAnual/ejercicio-anual.service';
import { DiaLaboralService } from 'src/app/services/diaLaboral/dia-laboral.service';
import { DiaLaboralModel } from 'src/app/services/diaLaboral/models/dia-laboral.model';
import { jqxDateTimeInputComponent } from 'jqwidgets-ng/jqxdatetimeinput';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD-MM-YYYY',
  },
  display: {
    dateInput: 'DD-MM-YYYY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

const PRIMERA_HORA_DIA = 0;
const PRIMER_MINUTO_DIA = 0;

const ULTIMA_HORA_DIA = 23;
const ULTIMO_MINUTO_DIA = 59;

const PRIMER_DIA_ANYO = 1;
const PRIMER_MES_ANYO = 1;

const ULTIMO_DIA_ANYO = 31
const ULTIMO_MES_ANYO = 12;

@Component({
  selector: 'app-gestion-tiempo-list',
  templateUrl: './gestion-tiempo-list.component.html',
  styleUrls: ['./gestion-tiempo-list.component.css'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class GestionTiempoListComponent implements OnInit {
  @ViewChild('winGestionTiempoList') winGestionTiempoList: jqxWindowComponent;
	@ViewChild('groupAnyo', { static: false }) groupAnyo: jqxRadioButtonGroupComponent;
  @ViewChild('groupDia', { static: false }) groupDia: jqxRadioButtonGroupComponent;

  @ViewChild('inputHoraDesde') inputHoraDesde: jqxDateTimeInputComponent;
  @ViewChild('inputHoraHasta') inputHoraHasta: jqxDateTimeInputComponent;

  @ViewChild('inputAnyoDesde') inputAnyoDesde: jqxDateTimeInputComponent;
  @ViewChild('inputAnyoHasta') inputAnyoHasta: jqxDateTimeInputComponent;

  private componentRef = null;
  public environment = environment;

  public diaLaboral: DiaLaboralModel = new DiaLaboralModel();
  public ejercicioAnual: EjercicioAnualModel = new EjercicioAnualModel();

  public localization = 'es-ES';

	itemsAnyo: any[] = [
    AppComponent.translate('Año_natural'),
    AppComponent.translate('Seleccionar'),
	]
  valueAnyo: any = this.itemsAnyo[0];

	itemsDia: any[] = [
    AppComponent.translate('Dia_natural'),
    AppComponent.translate('Seleccionar'),
	]
  valueDia: any = this.itemsDia[0];

  constructor
  (
    private ejercicioAnualService: EjercicioAnualService,
    private diaLaboralService: DiaLaboralService
  ) {}

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    this.getEjercicioAnual();
    this.getDiaLaboral();
  }

  public async init(componentRef: any) {
    this.componentRef = componentRef;
  }

  // Para traducir los textos
  public translate(text: string): string {
    return AppComponent.translate(text);
  }

  async getEjercicioAnual() {
    this.ejercicioAnual = await this.ejercicioAnualService.getEjercicioAnual();

    if(this.ejercicioAnual.inicio.dia === PRIMER_DIA_ANYO &&
      this.ejercicioAnual.inicio.mes === PRIMER_MES_ANYO &&
      this.ejercicioAnual.fin.dia === ULTIMO_DIA_ANYO &&
      this.ejercicioAnual.fin.mes === ULTIMO_MES_ANYO
    ){
      this.groupAnyo.checkAt(0);
    }else {
      this.groupAnyo.checkAt(1);
    }

    this.changeValueInputsAnual(
      this.ejercicioAnual.inicio.dia,
      this.ejercicioAnual.inicio.mes,
      this.ejercicioAnual.fin.dia,
      this.ejercicioAnual.fin.mes
    );
  }

  changeTipoEjercicio = (item) => {
    if(item.checked) {
      this.valueAnyo = item.value;

      if(this.valueAnyo === this.itemsAnyo[0]) {
        this.ejercicioAnual.inicio.dia = PRIMER_DIA_ANYO;
        this.ejercicioAnual.inicio.mes = PRIMER_MES_ANYO;


        this.ejercicioAnual.fin.dia = ULTIMO_DIA_ANYO;
        this.ejercicioAnual.fin.mes = ULTIMO_MES_ANYO;

        this.changeValueInputsAnual(
          this.ejercicioAnual.inicio.dia,
          this.ejercicioAnual.inicio.mes,
          this.ejercicioAnual.fin.dia,
          this.ejercicioAnual.fin.mes
        );
      }
    }
	}

  onChangeAnyoDesde(event) {
    let dateDesde: Date = event.args.newValue;
    this.ejercicioAnual.inicio.dia = dateDesde.getDate();
    this.ejercicioAnual.inicio.mes = (dateDesde.getMonth() + 1);

    this.calcularFin()
  }

  calcularFin() {
    let fechaHasta = new Date(`2000/${this.ejercicioAnual.inicio.mes}/${this.ejercicioAnual.inicio.dia}`);
    fechaHasta.setFullYear(fechaHasta.getFullYear() + 1);
    fechaHasta.setDate(fechaHasta.getDate() - 1);

    const dia = fechaHasta.getDate();
    const mes = (fechaHasta.getMonth() + 1);

    this.ejercicioAnual.fin.dia = dia;
    this.ejercicioAnual.fin.mes = mes;

    this.inputAnyoHasta.val(fechaHasta);
  }

  changeValueInputsAnual(
    diaDesde: number,
    mesDesde: number,
    diaHasta: number,
    mesHasta: number
  ) {
    let dateDesde = new Date();
    dateDesde.setDate(diaDesde);
    dateDesde.setMonth(mesDesde - 1);
    this.inputAnyoDesde.val(dateDesde);

    let dateHasta = new Date()
    dateHasta.setDate(diaHasta);
    dateHasta.setMonth(mesHasta - 1);
    this.inputAnyoHasta.val(dateHasta);
  }

  async getDiaLaboral() {
    this.diaLaboral = await this.diaLaboralService.getDiaLaboral();

    if(this.diaLaboral.inicio.hora === PRIMERA_HORA_DIA &&
      this.diaLaboral.inicio.minutos === PRIMER_MINUTO_DIA &&
      this.diaLaboral.fin.hora === ULTIMA_HORA_DIA &&
      this.diaLaboral.fin.minutos === ULTIMO_MINUTO_DIA
    ) {
      this.groupDia.checkAt(0);
    }else {
      this.groupDia.checkAt(1);
    }

    this.changeValueInputsHoras(
      this.diaLaboral.inicio.hora,
      this.diaLaboral.inicio.minutos,
      this.diaLaboral.fin.hora,
      this.diaLaboral.fin.minutos
    );
  }

  onChangeHoraDesde(event) {
    let horaDesde: Date = event.args.newValue;
    this.diaLaboral.inicio.hora = horaDesde.getHours();
    this.diaLaboral.inicio.minutos = horaDesde.getMinutes();
  }

  onChangeHoraHasta(event) {
    let horaHasta: Date = event.args.newValue;
    this.diaLaboral.fin.hora = horaHasta.getHours();
    this.diaLaboral.fin.minutos = horaHasta.getMinutes();
  }

  changeTipoDia = (item) => {
    if(item.checked) {
      this.valueDia = item.value;

      if(this.valueDia === this.itemsDia[0]) {
        this.changeValueInputsHoras(
          PRIMERA_HORA_DIA,
          PRIMER_MINUTO_DIA,
          ULTIMA_HORA_DIA,
          ULTIMO_MINUTO_DIA,
        );
      }
    }
  }

  changeValueInputsHoras(
    horaDesde: number,
    minutoDesde: number,
    horaHasta: number,
    minuteHasta: number
  ) {
    let dateDesde = new Date();
    dateDesde.setHours(horaDesde);
    dateDesde.setMinutes(minutoDesde);
    this.inputHoraDesde.val(dateDesde);

    let dateHasta = new Date()
    dateHasta.setHours(horaHasta);
    dateHasta.setMinutes(minuteHasta);
    this.inputHoraHasta.val(dateHasta);
  }

  async onGuardar() {
    await this.diaLaboralService.saveDiaLaboral(this.diaLaboral);
    await this.ejercicioAnualService.saveEjercicioAnual(this.ejercicioAnual);
  }

  public onClose() {
    if (this.componentRef) {
      this.componentRef.destroy();
    }
  }

  closeWindow() {
    this.winGestionTiempoList.close()
  }
}
